// extracted by mini-css-extract-plugin
export default {"limits":"styles_limits__v0XIw","limits__limit":"styles_limits__limit__SrT0T","limits__limit_time":"styles_limits__limit_time__ahKxq","limits__full":"styles_limits__full__E9K4x"};